import React, { useMemo } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";

const HEADERS = [
  { key: "pos", label: "Pos", width: 40 },
  { key: "behind", label: "Behind", width: 60 },
  { key: "ahead", label: "Ahead", width: 60 },
  { key: "lead", label: "Lead", width: 60 },
] as const;

export default function GapsTable({ carNumber }: { carNumber?: string }) {
  const activeStandings = useSelector(
    (state: RootState) =>
      state.aks?.v2?.timing?.session?.standings?.overall?.active,
    isEqual,
  );

  const { driverEntry, nextEntry, position } = useMemo(() => {
    if (!activeStandings || !carNumber)
      return { driverEntry: null, nextEntry: null, position: null };
    const entries = Object.entries(activeStandings);
    const found = entries.find(
      ([_, entry]) => String(entry.participant) === String(carNumber),
    );
    if (!found) return { driverEntry: null, nextEntry: null, position: null };
    const [pos, driver] = found;
    const index = entries.findIndex(([key]) => key === pos);
    return {
      driverEntry: driver,
      nextEntry: entries[index + 1]?.[1] ?? null,
      position: pos,
    };
  }, [activeStandings, carNumber]);

  return (
    <div className={styles.container}>
      <table>
        <colgroup>
          {HEADERS.map((header) => (
            <col key={header.key} style={{ width: `${header.width}px` }} />
          ))}
        </colgroup>
        <thead>
          <tr>
            {HEADERS.map((header) => (
              <th key={header.key}>{header.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{position ?? "-"}</td>
            <td>
              {nextEntry?.gapPreviousTime != null
                ? nextEntry.gapPreviousTime / 1000
                : "-"}
            </td>
            <td>
              {driverEntry?.gapPreviousTime != null
                ? driverEntry.gapPreviousTime / 1000
                : "-"}
            </td>
            <td>
              {driverEntry?.gapFirstTime != null
                ? driverEntry.gapFirstTime / 1000
                : "-"}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
